<script type='text/babel'>
import DragAndDropMixin from '@/mixins/DragAndDropMixin.vue';
export default {
    name: 'ElementTag',
    data () {
        return {};
    },
    props: {
        layer: {
            type: Object,
            required: true
        }
    },
    mixins: [DragAndDropMixin],
    render (h) {
        this.layer.attrs.domProps.draggable = true;
        return h(this.layer.tag,
            {
                ...this.layer.attrs,
                on: {
                    dragstart: (e) => this.dragstart_handler(e, this.layer, '', true),
                    drag: this.dragover_handler,
                    drop: this.drop_handler,
                    dragend: this.dragend_handler
                }
            },
            this.layer.value
        );
    }
};

</script>
